var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":_vm.title + '-卡券领取记录',"name":"first"}},[_c('receive',{attrs:{"get-status":_vm.receive}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }